module.exports = __webpack_public_path__ + "static/media/facebook.bb237f9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/facebook.svg
// module id = 899
// module chunks = 0